<template>
	<div>
		<div class="d-flex align-items-center gap-2 mb-2">
			<span class="fw-semibold">
				{{ work.length === 1 ? "Work" : `${work.length} Work rows` }}
			</span>
			<button
				class="btn btn-sm btn-outline-secondary ms-auto"
				@click="emit('clear')"
			>
				<i class="bi bi-x-lg"></i>
			</button>
		</div>

		<div
			v-for="row in work"
			:key="row.origin + row.id"
			class="border-bottom py-1"
		>
			<div class="d-flex gap-2 align-items-baseline">
				<span class="badge" :class="originBadge(row.origin)">{{
					row.origin
				}}</span>
				<span class="fw-semibold text-truncate">{{ row.title }}</span>
			</div>
			<div class="small text-muted">
				{{ row.priority ?? "—" }}
				<span v-if="row.due_at"> · due {{ formatDate(row.due_at) }}</span>
				· {{ row.target_summary }}
			</div>
		</div>

		<div v-if="directOnly" class="small text-muted mt-2">
			Direct work is already an Assignment; place it on a Route from the
			Assignments tab.
		</div>

		<!-- What this selection can start. The inputs for each are in its own
		     tool on the right rail, beside the rows and the ledger, so the work
		     being decided about stays in view while it is authored. These are
		     doors, not a second copy of either form. -->
		<div v-else class="mt-2">
			<button
				type="button"
				class="btn btn-link btn-sm p-0 d-block text-start"
				@click="emit('create-route')"
			>
				Create route…
			</button>
			<button
				type="button"
				class="btn btn-link btn-sm p-0 d-block text-start"
				@click="emit('create-assignments')"
			>
				Create assignments…
			</button>
			<p class="small text-body-secondary mt-1 mb-0">
				Both start with this selection — one assignment per Work row that has an
				H3 footprint.
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { OperationsWorkRow } from "@/type/api";

import { originBadge } from "./wire";

const props = defineProps<{ work: OperationsWorkRow[] }>();
const emit = defineEmits<{
	(e: "clear"): void;
	(e: "create-route"): void;
	(e: "create-assignments"): void;
}>();

/** Direct work is already an Assignment, so it is nothing this pane can start:
 * the two doors below would author a second row for the same work. */
const directOnly = computed(
	() =>
		props.work.length > 0 && props.work.every((row) => row.origin === "direct"),
);

function formatDate(value: string) {
	return new Date(value).toLocaleDateString();
}
</script>
